import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const GinStepsContext = createContext({});
export const GinStepsProvider = ({ children, viewMode, formState, formViewingProps, formFillingProps, formBuildingProps, stepsById, itemsById, pagesById, itemIdsByStepId, stepIdsByPageId, customRichTextParseOptions, downloadAsset, showItemVersions, activeContactId, }) => {
    return (_jsx(GinStepsContext.Provider, { value: {
            viewMode,
            formState,
            formViewingProps,
            formFillingProps,
            formBuildingProps,
            stepsById,
            itemsById,
            pagesById,
            itemIdsByStepId,
            stepIdsByPageId,
            customRichTextParseOptions,
            downloadAsset,
            showItemVersions,
            activeContactId,
        }, children: children }));
};
export const useGinSteps = () => useContext(GinStepsContext);
